export const tenant_vallcompanys_origin = ["stgsmartfarmgvc01.blob.core.windows.net"];

export const tenant_dev_nealia_origin = ["localhost", "test-feed.nealia.tech"];